
import {
  ConfigId,
  KeyenceModule,
  ScanResult,
  isKeyenceEnterpriseBrowser,
  defaultCodeTypeSetting,
  CodeTypeSetting,
} from '@/utils/keyenceHT/keyenceModules'
import { Options, Vue } from 'vue-class-component'
import { QRCODE_BARCODE_TYPE_REGEX } from '@/utils/constants'
import IconScanQR from '../svg/IconScanQR.vue'
import { PropSync } from 'vue-property-decorator'

@Options({
  components: {
    IconScanQR,
  },
})
export default class ScanButton extends Vue {
  @PropSync('loading', { type: Boolean }) _loading!: boolean
  backupCodeTypeSetting: CodeTypeSetting = defaultCodeTypeSetting

  get isEnterpriseBrowser(): boolean {
    return isKeyenceEnterpriseBrowser()
  }

  async mounted() {
    if (isKeyenceEnterpriseBrowser() && KeyenceModule && KeyenceModule.Scanner) {
      this.backupCodeTypeSetting = KeyenceModule.Scanner.getConfig(ConfigId.CodeType) as CodeTypeSetting
      KeyenceModule.Scanner.setConfig(ConfigId.CodeType, defaultCodeTypeSetting)

      KeyenceModule.Scanner.clearReadCallback()
      KeyenceModule.Scanner.setReadCallback('keyenceHandyTerminalScanResultCallback')
    }

    window.keyenceHandyTerminalScanResultCallback = (result: ScanResult) => {
      if (result.mDecodeResult !== 'SUCCESS') {
        return
      }
      const regexBarcodeId = QRCODE_BARCODE_TYPE_REGEX
      const resultString =
        typeof result.mStringData === 'string' ? result.mStringData : result.mStringData[0].toString()
      if (resultString.match(regexBarcodeId)) {
        const urlParts = resultString.split('/')
        const barcodeId = urlParts[urlParts.length - 1].trim()
        const projectId = urlParts[urlParts.length - 3].trim()
        this._loading = true
        this.$router.push({
          name: 'detail',
          params: {
            barcodeId: barcodeId,
            project: projectId,
          },
        })
      } else {
        const detectedText = resultString?.trim() || ''
        const projectCode = this.$route?.params?.project.split('@')
        if (projectCode.length > 1) projectCode.pop()
        this._loading = true
        this.$router.push({
          name: 'detail',
          params: { barcodeId: `projectCode=${projectCode[0]}` },
          query: { externalId: detectedText, isGenerateBarcode: 1 },
        })
      }
    }
  }

  async unmounted() {
    if (isKeyenceEnterpriseBrowser() && KeyenceModule && KeyenceModule.Scanner) {
      KeyenceModule.Scanner.setConfig(ConfigId.CodeType, this.backupCodeTypeSetting)
    }
  }

  async startScan() {
    KeyenceModule.Scanner.startRead()
  }
}
